/*
 * @Author: Jiangbo
 * @Date: 2022-07-12 15:05:40
 * @LastEditors: Jiangbo
 * @LastEditTime: 2024-02-26 11:00:17
 */
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'

 const app = createApp(App)
 app.use(ElementPlus)
 app.mount('#app')




